export const pessoasEndpoint = {
    // Pessoas Físicas
    pessoasFisicas: {
        listar: `/api/v1/pessoas/fisicas`,
        listarPorFiltro: `/api/v1/pessoas/fisicas/por-filtro`,
        listarConvites: `/api/v1/pessoas/fisicas/convites`,
        criar: `/api/v1/pessoas/fisicas`,
        obter: (id) => `/api/v1/pessoas/fisicas/${id}`,
        atualizar: (id) => `/api/v1/pessoas/fisicas/${id}`,
        exportar: `/api/v1/pessoas/fisicas/exportar`,

        // Coordenações e Subcoordenações
        obterCoordenacoes: (id) => `/api/v1/pessoas/fisicas/${id}/coordenacoes`,
        obterSubcoordenacoes: (id) => `/api/v1/pessoas/fisicas/${id}/subcoordenacoes`,

        // Pagamentos
        obterMeusPagamentos: (id) => `/api/v1/pessoas/fisicas/${id}/meus-pagamentos`,

        // Relatórios de Solicitação
        listarRelatoriosSolicitacoes: (id) => `/api/v1/pessoas/fisicas/${id}/relatorios-solicitacoes`,

        // Passagens
        obterPassagensEmitidas: (id) => `/api/v1/pessoas/fisicas/${id}/passagens-emitidas`,

        // Funcionario
        verificarFuncionario: (id) => `/api/v1/pessoas/fisicas/${id}/funcionario`,

        listarProjetosPorPessoaFisica: (id) => `/api/v1/pessoas/fisicas/${id}/projetos`,
    },

    // Carteira de Motorista
    carteiraMotorista: {
        listar: `/api/v1/pessoas/fisicas/carteira-motorista`,
        listarPorFiltro: `/api/v1/pessoas/fisicas/carteira-motorista/por-filtro`,
        criar: (pessoa_fisica_id) => `/api/v1/pessoas/fisicas/${pessoa_fisica_id}/carteira-motorista`,
        obter: (pessoa_fisica_id) => `/api/v1/pessoas/fisicas/${pessoa_fisica_id}/carteira-motorista`,
        atualizar: (pessoa_fisica_id) => `/api/v1/pessoas/fisicas/${pessoa_fisica_id}/carteira-motorista`,
        baixarArquivo: (pessoa_fisica_id) => `/api/v1/pessoas/fisicas/${pessoa_fisica_id}/carteira-motorista/arquivo`,
        // apagar: (pessoa_fisica_id) => `/api/v1/pessoas/fisicas/${pessoa_fisica_id}/carteira-motorista`,
    },

    // Pessoas Jurídicas
    pessoasJuridicas: {
        listar: `/api/v1/pessoas/juridicas`,
        listarPaginado: `/api/v1/pessoas/juridicas/paginado`,
        listarPorFiltro: `/api/v1/pessoas/juridicas/por-filtro`,
        obterPorCnpj: `/api/v1/pessoas/juridicas/por-cnpj`,
        criar: `/api/v1/pessoas/juridicas`,
        obter: (id) => `/api/v1/pessoas/juridicas/${id}`,
        atualizar: (id) => `/api/v1/pessoas/juridicas/${id}`,
    },

    // Convites e Tokens
    convites: {
        enviarConvite: `/api/v1/pessoas/fisicas/convites/token`,
        enviarConvitesLote: `/api/v1/pessoas/fisicas/convites/lote`,
        reenviarConvites: `/api/v1/pessoas/fisicas/convites/reenviar`,
        solicitarTokenCompartilhado: (dias) => `/api/v1/pessoas/fisicas/convites/token-compartilhado/${dias}`,
    },

    contratos: {
        listar: (pessoa_fisica_id) => `/api/v1/pessoas/fisicas/${pessoa_fisica_id}/contratos-projeto`,
    },

    // Histórico de alterações cadastrais (PF e PJ)
    historicoAlteracoes: {
        listar: `/api/v1/pessoas/historico-alteracoes`,
    }
}
